const MuiTooltip = (tokens) => {
    const { component: { tooltip }, core, } = tokens;
    return {
        MuiTooltip: {
            defaultProps: {
                arrow: true,
            },
            styleOverrides: {
                tooltip: {
                    filter: `drop-shadow(${tooltip.boxShadow.value.layers[0].offsetX} ${tooltip.boxShadow.value.layers[1].offsetY} ${tooltip.boxShadow.value.layers[1].blur} ${tooltip.boxShadow.value.layers[1].color})`,
                    fontSize: tooltip.fontSize.value,
                    lineHeight: tooltip.lineHeight.value,
                    fontWeight: tooltip.fontWeight.value,
                    padding: `${tooltip.paddingVertical.value} ${tooltip.paddingHorizontal.value}`,
                    borderRadius: tooltip.borderRadius.value,
                    maxWidth: tooltip.maxWidth.value,
                    maxHeight: tooltip.maxHeight.value,
                    // default light theme
                    backgroundColor: tooltip.light.backgroundColor.value,
                    color: tooltip.light.color.value,
                },
                popper: {
                    filter: `drop-shadow(${tooltip.boxShadow.value.layers[0].offsetX} ${tooltip.boxShadow.value.layers[0].offsetY} ${tooltip.boxShadow.value.layers[0].blur} ${tooltip.boxShadow.value.layers[0].color})`,
                },
                arrow: {
                    overflow: "visible",
                    "&&::before": {
                        width: 0,
                        height: 0,
                        borderLeft: `${core.spacing["1_5"].value} solid transparent`,
                        borderRight: `${core.spacing["1_5"].value} solid transparent`,
                        borderBottom: `14px solid ${tooltip.light.backgroundColor.value}`,
                        backgroundColor: "transparent",
                    },
                },
                tooltipPlacementTop: {
                    "&& .MuiTooltip-arrow::before": {
                        transform: "rotate(180deg) translateX(3px)",
                        transformOrigin: "center",
                    },
                },
                tooltipPlacementBottom: {
                    "&& .MuiTooltip-arrow::before": {
                        transform: "rotate(0deg) translate(-3px, -2px)",
                        transformOrigin: "center",
                    },
                },
                tooltipPlacementLeft: {
                    "&& .MuiTooltip-arrow::before": {
                        transform: "rotate(90deg) translateY(5px)",
                        transformOrigin: "center",
                    },
                },
                tooltipPlacementRight: {
                    "&& .MuiTooltip-arrow::before": {
                        transform: "rotate(270deg) translateY(-7px)",
                        transformOrigin: "center",
                    },
                },
            },
        },
    };
};
export default MuiTooltip;
export const TooltipPresets = (tokens) => {
    const { tooltip } = tokens.component;
    return {
        type: {
            light: {
                componentsProps: {
                    tooltip: {
                        sx: {
                            backgroundColor: tooltip.light.backgroundColor.value,
                            color: tooltip.light.color.value,
                        },
                    },
                    arrow: {
                        sx: {
                            "&&::before": {
                                borderBottomColor: tooltip.light.backgroundColor.value,
                            },
                        },
                    },
                },
            },
            dark: {
                componentsProps: {
                    tooltip: {
                        sx: {
                            backgroundColor: tooltip.dark.backgroundColor.value,
                            color: tooltip.dark.color.value,
                        },
                    },
                    arrow: {
                        sx: {
                            "&&::before": {
                                borderBottomColor: `${tooltip.dark.backgroundColor.value}`,
                            },
                        },
                    },
                },
            },
        },
    };
};
//# sourceMappingURL=tooltip.js.map